import React from 'react';
import ReportFrame from '../ReportFrame';

export default class ArAgeingReport extends React.Component {
  render() {
    return (
      <div className='contentwrapperiframe bg-white'>
        <iframe
          src='https://app.powerbi.com/view?r=eyJrIjoiOWM4OWVmOGMtYWIzZi00Nzg0LWE0NmItN2I2M2EzNGMyODBiIiwidCI6IjE0NWE1Yjg1LTkzYWEtNDg2OC1hZmEwLWFkZWRjOTA0ZWM3YSIsImMiOjF9'
          title='ARAgingDetailReport'
          className='report-frame'
          id='arageingreport'
          name='arageingreport'
        />
      </div>
    );
  }
}

       
